import React from "react";
import { IconsProps } from "./Icons";

export const CallIconDash = ({
  className,
  fill,
  width,
  height,
  viewBox,
}: IconsProps) => {
  return (
    <svg
      className={className}  
      width={width || "40"}
      height={height || "40"}
      viewBox={viewBox || "0 0 40 40"}
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M16 3.7V0.5H32V3.7H16ZM16 10.1V6.9H32V10.1H16ZM16 16.5V13.3H32V16.5H16ZM27.12 32.5C23.7867 32.5 20.4933 31.7736 17.24 30.3208C13.9867 28.868 11.0267 26.8077 8.36 24.14C5.69333 21.4723 3.6336 18.5123 2.1808 15.26C0.728 12.0077 0.00106667 8.7144 0 5.38C0 4.9 0.16 4.5 0.48 4.18C0.8 3.86 1.2 3.7 1.68 3.7H8.16C8.53333 3.7 8.86667 3.82693 9.16 4.0808C9.45333 4.33467 9.62667 4.6344 9.68 4.98L10.72 10.58C10.7733 11.0067 10.76 11.3667 10.68 11.66C10.6 11.9533 10.4533 12.2067 10.24 12.42L6.36 16.34C6.89333 17.3267 7.5264 18.2803 8.2592 19.2008C8.992 20.1213 9.79893 21.0077 10.68 21.86C11.5067 22.6867 12.3733 23.4536 13.28 24.1608C14.1867 24.868 15.1467 25.5144 16.16 26.1L19.92 22.34C20.16 22.1 20.4736 21.9203 20.8608 21.8008C21.248 21.6813 21.6277 21.6477 22 21.7L27.52 22.82C27.8933 22.9267 28.2 23.1203 28.44 23.4008C28.68 23.6813 28.8 23.9944 28.8 24.34V30.82C28.8 31.3 28.64 31.7 28.32 32.02C28 32.34 27.6 32.5 27.12 32.5Z"
        fill="#5AAD2F"
      />
    </svg>
  );
};
